import graphql__2decfe2ecd76cbf302f9 from "./__generated__/ParticipativeModuleMeasures_participativeModule.graphql.js";import { useFragment } from "react-relay";
import { graphql } from "react-relay";
import classNames from "classnames";
import padStart from "lodash/padStart";

import { isUnauthorized } from "../Utils/authorizations";
import Icon from "../Utils/Icon";

export const ParticipativeModuleMeasures = props => {
  const participativeModule = useFragment(
    ParticipativeModuleMeasures_participativeModule,
    props.participativeModule
  );
  const { hideVotes, hideContributions } = props;
  const { authorizations } = participativeModule;
  const { votesDisplayAuthorized, votesDownAuthorized } = authorizations;

  const displayVotes = !isUnauthorized(votesDisplayAuthorized) && !hideVotes;
  const displayVotesDown = !isUnauthorized(votesDownAuthorized) && !hideVotes;
  const votesUpCount = displayVotes && padStart(participativeModule.votesUpCount, 2, "0");
  const votesDownCount =
    displayVotesDown && padStart(participativeModule.votesDownCount, 2, "0");

  const displayContributionsCount =
    !isUnauthorized(authorizations.contributionsCountDisplayAuthorized) && 
    !hideContributions;
  const contributionsCount =
    displayContributionsCount && padStart(participativeModule.contributionsCount, 2, "0");

  const textClassName = props.textClassName || "text-metric";

  const className = classNames([
    "votes-count",
    "d-flex",
    "align-items-center",
    "text-align-center",
    textClassName,
    props.className
  ]);

  // Do not show the module if it has nothing to display
  if (!displayVotes && !displayContributionsCount) return null;

  return (
    <div className={className}>
      {displayContributionsCount && (
        <div className="contributions-count text-metric margin-right-xs with-icon">
          <span className="with-icon-text">{contributionsCount}</span>
          <Icon className="icon-contribute text-primary votes-count-icon margin-left-xxs" />
        </div>
      )}

      {displayVotes && (
        <>
          <div className="votes-count-up text-metric with-icon">
            <span className="with-icon-text">{votesUpCount}</span>
            <Icon className="icon-like text-success votes-count-icon margin-left-xxs" />
          </div>

          {displayVotesDown && (
            <div className="votes-count-down text-metric with-icon margin-left-xs">
              <span className="with-icon-text">{votesDownCount}</span>
              <Icon className="icon-dislike text-danger votes-count-icon margin-left-xxs" />
            </div>
          )}
        </>
      )}
    </div>
  );
};

const ParticipativeModuleMeasures_participativeModule = graphql__2decfe2ecd76cbf302f9;

export default ParticipativeModuleMeasures;
